import React from 'react';
import { Divider } from 'wix-ui-tpa/cssVars';
import { classes } from './Divider.st.css';

export default () => {
  return <Divider className={classes.root} />;
};
